import { defineNuxtPlugin } from '#app';
import { checkAndFetchAuth } from '~/utils/auth';

export default defineNuxtPlugin(async (nuxtApp) => {
    // Only run on client-side
    if (process.server) return;
    
    // Check and fetch auth if needed
    await checkAndFetchAuth();
}); 